import { DeliveryMethod } from "../constants";

const onlyLabelPrint = (defaultLocale: string | undefined | null, deliveryMethod: string | null | undefined): boolean => {
  return (defaultLocale === "lt" || defaultLocale === "lv") && deliveryMethod === DeliveryMethod.DoorToPudo;
}

export default onlyLabelPrint;